'use client'
import {
  Headline,
  Subheadline,
  Container,
  ContentWrapper,
  CTAContainer
} from '@/components/ui'
import { CTAButton } from '@/components/ui/cta-button'
import MediaContainer from '@/components/ui/MediaContainer'
import GradientContainer from '@/components/ui/GradientContainer'
import { useCTAUrl } from '@/lib/use-cta-url'
import { useABTest } from '@/components/analytics/useABTest'
import { GradientVariant, HeadlineVariant } from '@/types/ui'
import { usePageSettings } from '@/components/contexts/PageSettingsContext'
interface DictationProps {
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const Dictation = ({ 
  gradientVariant = '12', 
  headlineVariant,
  title = "Ultra-accurate voice-to-text built in.",
  subtitle = "Just talk. Hypertask captures your thoughts, even in chaos hands-free, multilingual, and instant."
}: DictationProps) => {
  const { enableDictationGoogleLogin, showGoogleLogoDictation } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
      <Container variant="section">
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
            {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
               <MediaContainer 
               src="/images/sections/1758547129111dictate.avif" 
               type="image"
               alt="Dictation Functions"
               className='md:max-w-[75%]'
             />
            
         
          </GradientContainer>
           
          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              enableGoogleLogin={enableDictationGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoDictation}
              external={ctaUrl.startsWith('http')}
            >
              Get Started
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
  )
}

export default Dictation